<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.searchKey"
              :placeholder="
                $l('from_label_department_code_name') ||
                  '部门编码/部门名称搜索…… '
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="add()"
              v-if="allow('A')"
            >
              <!-- <b-icon-plus></b-icon-plus> -->
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('updateLevel')"
              v-if="allow('M')"
            >
              {{ $l('btn_updateLevel') || '修改层级' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="650px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('from_label_department_name') || '部门名称'"
            >
              <el-input
                v-model.trim="form.depName"
                :placeholder="
                  $l('from_label_ps_department_name') || '请输入部门名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-row>
            <el-form-item
              :label="$l('from_label_department_code') || '部门编码'"
            >
              <el-input
                v-model.trim="form.depNo"
                :placeholder="
                  $l('from_label_ps_parameter_ID') || '请输入部门编码'
                "
                clearable
              >
              </el-input>
            </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item
            :label="$l('form_label_modification_date') || '修改日期'"
          >
            <el-col :span="24">
              <el-col :span="11">
                <el-date-picker
                  v-model="form.modifyTimeStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('form_label_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  v-model="form.modifyTimeEnd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('form_label_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-col>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$l('from_radio_valid_status') || '有效状态'">
              <el-checkbox-group v-model="form.depStatusList">
                <el-checkbox label="Y">{{
                  $l('INDEX.form_label_valid') || '有效'
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l('INDEX.form_label_invalid') || '无效'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  searchKey: '',
  depStatusList: ['Y']
}

export default {
  props: {
    depRow: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      orgRow: {}
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    orgChange(row) {
      this.orgRow = row
      this.query()
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', { ...this.form, orgCode: this.orgRow.orgCode })
    },
    // 高级查询
    advquery() {
      this.form.searchKey = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    add() {
      const { depCode } = this.depRow
      const { orgCode } = this.orgRow

      if (!depCode) {
        if (!orgCode) {
          this.$message.warning(
            this.$l('from_label_pe_department') || '请先选择一个部门！'
          )
          return
        }
      }
      this.$emit('openEditFormDialog', { type: 'add' })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
